import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import './MfSchemeCard.css'

function MfSchemeCard(props, ref) {
    const { MFcode } = useParams();
    let getMFCode = props.MFcode;
    const [data, setData] = useState([]);
    const [chartdata, setchartData] = useState([]);
    const [chartperiod, setchartperiod] = useState('1M');
    const { BaseURL } = useContext(URLstateContext);
    const [compname, setcompname] = useState([]);
    let getData, getchartData, getcompname;
    useEffect(() => {
        if(getMFCode != '') {
        const getUrl = BaseURL + "GetQuoteDetailsMF";
        // alert(`${getUrl}/${MFCode}`)
        fetch(`${getUrl}/${getMFCode}`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setchartData(getchartData);
                getcompname = data.data[0]["SchemeName"];
                setcompname(getcompname);
                // console.log(getcompname)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
        }

    }, [getMFCode]);


   
    return (
        <>
            <section className="scheme-fundamental-sectionKey">
                <Container className="add-border ">
                    <Row>
                        <Col md={12}>
                            <div className="table-boxkeystateMf scheme-fundamental-sectionKey">
                            <div className="divcompanyname">
                                   <div className="companyname">{compname}</div>
                                   <div className="keystateMF">NAV Details</div>
                                   {data == null ?  <h5 className="errormsgComNew"> No Data Found !!! </h5>:''}
                                 </div>
                                  <ul className="key-list-mf">
                                    {data != null && data.map((eachData) => (
                                        <>
                                            <li>
                                                <span>NAV Date</span>
                                                <h5> {(eachData.CurrNavDate != null) ? (eachData.CurrNavDate.split('T')[0]) : eachData.CurrNavDate = ''}</h5>
                                            </li>
                                            <li>
                                                <span>NAV</span>
                                                <h5> {(eachData.CurrNAV != null) ? eachData.CurrNAV.toFixed(2) : eachData.CurrNAV = 0}</h5>
                                            </li>
                                            <li>
                                                <span>Minimum Investment</span>
                                                <h5> {(eachData.mininvt != null) ? eachData.mininvt : eachData.mininvt = 0}</h5>
                                            </li>
                                            <li>
                                                <span>Asset Size</span>
                                                <h5> {
                                                    (eachData.AssetSize != null) ? eachData.AssetSize.toFixed(2) : eachData.AssetSize = 0
                                                }</h5>
                                            </li>
                                            <li>
                                                <span>52 week high</span>
                                                <h5> {(eachData.nav52WH != null) ? eachData.nav52WH.toFixed(2) : eachData.nav52WH = 0}</h5>
                                            </li>
                                            <li>
                                                <span>Type</span>
                                                <h5> {(eachData.schemetype != null) ? eachData.schemetype : eachData.schemetype = ''}</h5>
                                            </li>
                                            <li>
                                                <span>Prev. NAV</span>
                                                <h5> {
                                                    (eachData.PrevNAV != null) ? eachData.PrevNAV.toFixed(2) : eachData.PrevNAV = 0
                                                }</h5>
                                            </li>
                                            <li>
                                                <span>Fund Type</span>
                                                <h5> {(eachData.schemeOption != null) ? eachData.schemeOption : eachData.schemeOption = ''}</h5>
                                            </li>
                                            <li>
                                                <span>52 week low</span>
                                                <h5> {(eachData.nav52WL != null) ? eachData.nav52WL.toFixed(2) : eachData.nav52WL = 0}</h5>
                                            </li>
                                            <li>
                                                <span>Category </span>
                                                <h5> {(eachData.SchemeCategory != null) ? eachData.SchemeCategory : eachData.SchemeCategory = ''}</h5>
                                            </li>
                                        </>
                                    ))}

                                </ul>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default MfSchemeCard